'use client'

export default function PrintButton() {
  return (
    <button
      onClick={() => window.print()}
      className="print:hidden inline-flex items-center rounded-md text-sm font-medium text-primary-100 underline underline-offset-2 hover:text-primary-80"
    >
      PDF Version
    </button>
  )
}
